import React, {Component} from "react";
import {NavLink} from "react-router-dom/cjs/react-router-dom.min";
import FlexView from "react-flexview";
import Container from "../../../../modules/commons/Container";

class DashboardSales extends Component {
    constructor(props) {
        super(props);
    }

    createSubMenu = (val, link, icon, id) => {
        return (
            <NavLink id={id} to={link}>
                <div
                    className="content"
                    style={{


                        borderWidth: 2,
                        borderColor: "#000000",
                        backgroundColor: "#E74C3C",
                        borderStyle: "solid",
                        borderRadius: 5,
                        width: 235,
                        height: 235,
                        justifyContent: "space-evenly",
                    }}
                >
                    <div
                        className="list"
                        style={{
                            marginTop: "35%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#ffffff",

                            alignContent: "center",
                        }}
                    >
                        <div className="icn" style={{marginRight: 10}}>
                            <i className={`${icon} fa-lg`}></i>
                        </div>
                        <div className="ttl">{val}</div>
                        <div className="icn icn-right txt-site txt-right txt-12"/>
                    </div>
                </div>
            </NavLink>
        );
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView style={{gap: "20px"}}>
                        {this.createSubMenu(
                            "Laporan Harian Sales - CS",
                            "/dashboard/sales/sales",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_sales_sales"
                        )}
                        {this.createSubMenu(
                            "Laporan Jual Varian",
                            "/dashboard/sales/variant",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_sales_variant"
                        )}
                    </FlexView>
                </Container>
            </>
        )
    };
}

export default DashboardSales;